import { useCallback } from 'react';
import { useClipControls } from './_internal/useClipControls';
import { usePlaybackControls } from './_internal/usePlaybackControls';
import { toAudioPrecision } from '../../utils/mediaPlayerUtils';
import { mediaPlaybackActions } from '../stores/AudioPlaybackStore';
import { getInitialMediaPlaybackState } from '../utils/getInitialMediaPlaybackState';
export const useMediaPlayback = ({
  audioDurationInSeconds,
  clipEndTime,
  clipStartTime,
  containInClipTime = false,
  initialClipEndTime,
  initialClipStartTime,
  mediaRef,
  mediaStateDispatch,
  preciseDuration,
  source,
  status
}) => {
  const handleSetPlayerHeadLocation = useCallback(time => {
    const audioTime = toAudioPrecision(time, preciseDuration);
    mediaStateDispatch(mediaPlaybackActions.setCurrentTime(audioTime));
    if (mediaRef.current && !isNaN(mediaRef.current.currentTime)) {
      mediaRef.current.currentTime = audioTime;
    }
  }, [preciseDuration, mediaStateDispatch, mediaRef]);
  const handleReset = useCallback(() => {
    var _mediaRef$current;
    mediaStateDispatch(mediaPlaybackActions.reset(getInitialMediaPlaybackState(audioDurationInSeconds, initialClipEndTime, initialClipStartTime)));
    (_mediaRef$current = mediaRef.current) === null || _mediaRef$current === void 0 || _mediaRef$current.load();
  }, [audioDurationInSeconds, initialClipEndTime, initialClipStartTime, mediaRef, mediaStateDispatch]);
  const {
    handlePause,
    handlePlayerHeadUpdate,
    handleForward,
    handlePlay,
    handleRewind
  } = usePlaybackControls({
    clipEndTime,
    clipStartTime,
    containInClipTime,
    handleSetPlayerHeadLocation,
    mediaRef,
    mediaStateDispatch,
    preciseDuration,
    source,
    status
  });
  const {
    handleSetClipEndTime,
    handleSetClipStartTime
  } = useClipControls({
    mediaRef,
    mediaStateDispatch,
    clipStartTime,
    clipEndTime,
    handleSetPlayerHeadLocation,
    handlePause,
    preciseDuration,
    status
  });
  return {
    forward: handleForward,
    pause: handlePause,
    play: handlePlay,
    onPlayerHeadUpdate: handlePlayerHeadUpdate,
    rewind: handleRewind,
    reset: handleReset,
    setClipEndTime: handleSetClipEndTime,
    setClipStartTime: handleSetClipStartTime,
    setPlayerHeadLocation: handleSetPlayerHeadLocation
  };
};